import { TODAY_DATE } from '@barbershop/shared/model'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

import { ShiftsPage } from '@/pages/shifts-page'

const ShiftsSearchSchema = z.object({
    barber_id: z.coerce.number().int().positive().optional(),
    date: z.iso.date().default(TODAY_DATE),
})

export const Route = createFileRoute('/_dashboard-layout/shifts')({
    component: ShiftsPage,
    validateSearch: ShiftsSearchSchema,
})
